import React from "react";
import {
  Box,
  Typography,
  Paper,
  alpha,
  useTheme,
  Chip,
  Button,
} from "@mui/material";
import { LocalDining, AddShoppingCart } from "@mui/icons-material";
import OrderItemCard from "./OrderItemCard";

const OrderItemsSection = ({
  orderDetails,
  formatCurrency,
  compact = false,
  onAddItems,
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: "white",
        borderRadius: "16px",
        p: compact ? 1.5 : 2.5,
        border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
        boxShadow: `0 2px 8px ${alpha("#000", 0.04)}`,
        height: "100%",
      }}
    >
      <Typography
        variant={compact ? "subtitle1" : "h6"}
        sx={{
          fontWeight: 700,
          color: theme.palette.text.primary,
          mb: compact ? 1.5 : 2,
          display: "flex",
          alignItems: "center",
          gap: compact ? 1 : 1.5,
        }}
      >
        <Box
          sx={{
            width: compact ? 32 : 36,
            height: compact ? 32 : 36,
            borderRadius: "10px",
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        >
          <LocalDining sx={{ fontSize: compact ? 16 : 20, color: "white" }} />
        </Box>
        Order Items
        <Chip
          label={orderDetails.OrderItems?.length || 0}
          size="small"
          sx={{
            height: 24,
            fontWeight: 700,
            bgcolor: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.main,
          }}
        />
        {onAddItems && (
          <Button
            size="small"
            variant="contained"
            onClick={onAddItems}
            startIcon={<AddShoppingCart sx={{ fontSize: "14px !important" }} />}
            sx={{
              ml: "auto",
              height: 28,
              px: 1.5,
              fontSize: "0.72rem",
              fontWeight: 700,
              textTransform: "none",
              borderRadius: "8px",
              background: `linear-gradient(135deg, #10b981 0%, #059669 100%)`,
              boxShadow: `0 2px 8px ${alpha("#10b981", 0.35)}`,
              "&:hover": {
                background: `linear-gradient(135deg, #059669 0%, #047857 100%)`,
                transform: "translateY(-1px)",
                boxShadow: `0 4px 12px ${alpha("#10b981", 0.45)}`,
              },
              transition: "all 0.2s ease",
            }}
          >
            Add Items
          </Button>
        )}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: compact ? 1 : 2,
          // Always reserve height for 3 compact cards (≈90px each + gaps)
          height: compact ? "290px" : "none",
          minHeight: compact ? "290px" : "none",
          overflowY: "auto",
          pr: compact ? 0.5 : 0,
          // Subtle inner scrollbar
          "&::-webkit-scrollbar": { width: "4px" },
          "&::-webkit-scrollbar-track": { bgcolor: "transparent" },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: alpha(theme.palette.primary.main, 0.2),
            borderRadius: "4px",
          },
        }}
      >
        {orderDetails.OrderItems?.map((item, index) => (
          <OrderItemCard
            key={index}
            item={item}
            formatCurrency={formatCurrency}
            compact={compact}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default OrderItemsSection;
